<template>
	<div class="inventory__card">
		<div class="boat__year">{{ inventory?.boat?.model_year }}</div>
		<div class="boat__name">
			<h3>{{ inventory?.boat?.name }}</h3>
		</div>
		<div class="boat__image" @click.prevent="$navigate('/inventory/' + inventory.id)">
			<img class="bottom__img" :src="image" alt="boat">
		</div>
		<div class="boat__details">
			<div class="price">
				<div class="msrp text-sm">MSRP</div>
				<div>
					${{ inventory.msrp_price }} 
				</div>
			</div>
			<div class="colors">
				<color-swatch :color="inventory?.exterior_color" label="Hull Color"></color-swatch>
				<color-swatch :color="inventory?.accent_color" label="Hull Accent Color"></color-swatch>
				<color-swatch :color="inventory?.upper_color" label="Upper Hull Color"></color-swatch>
				<color-swatch :color="inventory?.lower_color" label="Lower Hull Color"></color-swatch>
				<color-swatch :color="inventory?.interior_color" label="Interior Color"></color-swatch>
				<!--<color-swatch :color="inventory?.canvas_color" label="Canvas Color"></color-swatch>-->
			</div>
		</div>
		<div class="card__links">
			<a href="#" @click.prevent="$emit('showroom', inventory)">Request Showroom Visit</a>
		</div>
		<div class="card__cta">
			<router-link :to="'/inventory/' + inventory.id" class="btn">View Details</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['value'],
		data() {
			return {
				inventory: this.value
			};
		},
		computed: {
			exterior_image() {
				if(!this.inventory || !this.inventory.exterior_color || !this.inventory.exterior_color.image) {
					return '';
				}
				return this.inventory.exterior_color.image.thumb100;
			},
			interior_image() {
				if(!this.inventory || !this.inventory.interior_color || !this.inventory.interior_color.image) {
					return '';
				}
				return this.inventory.interior_color.image.thumb100;
			},
			image() {
				if(!this.inventory) {
					return '/images/front/BMT.png';
				}
				if(this.inventory.featured_image && this.inventory.featured_image.thumb600) {
					return this.inventory.featured_image.thumb600;
				}
				if(this.inventory.boat && this.inventory.boat.featured_image && this.inventory.boat.featured_image.thumb600) {
					return this.inventory.boat.featured_image.thumb600;
				}
				return '/images/front/BMT.png';
			}
		},
		watch: {
			value() {
				this.inventory = this.value;
			},
			inventory() {
				this.$emit('input', this.inventory);
			}
		}
	}
</script>